export default __webpack_public_path__ + "static/media/IN.d98dd61c.svg";